import { useEffect, useState } from "react";
import {Card, Table} from "react-bootstrap";
import Loader from "../../../../../components/common/loader/loader.tsx";
import { usePaginator } from "@components/paginator/usePaginator.tsx";
import Paginator from "@components/paginator/Paginator.tsx";
import {Trace} from "@models/trace.model.ts";
import {TracerService} from "@services/tracer/tracerService.ts";
import {TraceRow} from "./TraceRow.tsx";
import {TraceFilter} from "./TraceFilter.tsx";
import traceStore from "../../../traceStore.ts";
import {useSnapshot} from "valtio";



export const TracesListTable = () => {
  const [traceList, setTraceList] = useState<Trace[]>([]);
  const [isLoading, _] = useState<boolean>(false);

  const paginator = usePaginator();
  const traceStoreSnap = useSnapshot(traceStore);


  useEffect(() => {

    const getTraces = async () => {

      try {

        const service = new TracerService();
        const traceList = await service.getTraceList(
            traceStore.filterHttpMethod,
            traceStore.filterStatus,
            traceStore.filterSearch,
            -1,
            paginator.state.limit,
            paginator.state.offset
        );
        paginator.events.setSizeOfCurrentPage(traceList.length);
        setTraceList(traceList);

      } catch (error) {
        console.error("Get Traces List:", error);
        throw error;
      }
    }

    getTraces().then()

  }, [traceStoreSnap.filterHttpMethod,
            traceStoreSnap.filterStatus,
            traceStoreSnap.filterSearch,
            paginator.state.limit,
            paginator.state.offset,]);


  return (
    <>
      <TraceFilter />
      <Card.Body>
        {isLoading && <Loader />}
          <Table className="table text-nowrap table-hover"
                 style={{ border: "1px solid #f3f3f3",
                          borderRadius: "8px",
                          overflow: "hidden",
                          borderCollapse: "separate"}}>
            <thead>
              <tr>
                <th className="text-white bg-primary" scope="col" style={{width: 190}}>
                  <b>Executed By</b>
                </th>
                <th className="text-white bg-primary" scope="col">
                  <b>Request</b>
                </th>
                <th className="text-white bg-primary text-center" scope="col" style={{width: 90}}>
                  <b>Status</b>
                </th>
                <th className="text-white bg-primary text-center" scope="col" style={{width: 90}}>
                  <b>Duration</b>
                </th>
                <th className="text-white bg-primary text-center" scope="col" style={{width: 90}}>
                  <b>Action</b>
                </th>
              </tr>
            </thead>
            <tbody>
              {traceList && traceList.map((item: Trace) => (
                  <TraceRow key={item.id} trace={item} />
                ))
              }
            </tbody>
          </Table>

      </Card.Body>

      <Card.Footer className="">
        <Paginator paginator={paginator}/>
      </Card.Footer>

    </>
  );
};


/*



 */
